import useFormattedNumber from "#React/hooks/formatters/useFormattedNumber"

type FormattedHumanNumberProps = {
  value: number | null
  precision?: number
}

const FormattedHumanNumber = ({ value, precision = 2 }: FormattedHumanNumberProps) => {
  const { formatNumberToHuman, formatNumberWithPrecision } = useFormattedNumber()

  const formattedNumber = formatNumberWithPrecision(value, precision)
  const label = formatNumberToHuman(value, precision)

  return <span title={formattedNumber}>{label}</span>
}

export default FormattedHumanNumber
